import { useCallback } from 'react';
import { notification } from 'antd';
import { CREATE_TASK_TIMEOUT_MS, emitWhenConnected } from '../socketHelpers';

export function useGlobalSearchApi(socket) {
  const createGlobalImageSearchTask = useCallback(
    (yandexImageSearchPayload, callback) => {
      if (!socket) {
        if (callback) callback('Сокет не подключен', null);
        return;
      }

      const description =
        typeof yandexImageSearchPayload === 'string'
          ? { yandexImageSearch: yandexImageSearchPayload }
          : yandexImageSearchPayload;

      emitWhenConnected(socket, () => {
        let finished = false;
        const timer = setTimeout(() => {
          if (finished) return;
          finished = true;
          notification.warning({
            message: 'Таймаут',
            description: 'Сервер не ответил на создание задачи вовремя',
          });
          if (callback) callback('Таймаут создания задачи', null);
        }, CREATE_TASK_TIMEOUT_MS);

        socket.emit('create_task', { description }, (response) => {
          if (finished) return;
          finished = true;
          clearTimeout(timer);
          if (response?.status === 'ok' && response.task) {
            if (callback) callback(null, response.task);
          } else {
            const msg = response?.message || 'Ошибка создания задачи';
            if (callback) callback(msg, null);
            notification.error({ message: 'Глобальный поиск', description: msg });
          }
        });
      });
    },
    [socket]
  );

  const getGlobalSearchTaskList = useCallback(
    (options, callback) => {
      if (!socket) {
        if (callback) callback('Сокет не подключен', null);
        return;
      }

      const payload = {
        limit: options?.limit ?? 50,
        requestType: 'yandexImageSearch',
        includeResult: options?.includeResult !== false,
      };

      emitWhenConnected(socket, () => {
        socket.emit('get_tasks_with_requests', payload, (response) => {
          if (response?.status === 'ok') {
            if (callback) callback(null, response.tasks || []);
          } else {
            const msg = response?.message || 'Не удалось загрузить историю';
            if (callback) callback(msg, null);
            notification.error({ message: 'История запросов', description: msg });
          }
        });
      });
    },
    [socket]
  );

  const getGlobalSearchTaskDetail = useCallback(
    (taskId, callback) => {
      if (!socket) {
        if (callback) callback('Сокет не подключен', null);
        return;
      }

      emitWhenConnected(socket, () => {
        socket.emit('get_task_with_requests', { taskId }, (response) => {
          if (response?.status === 'ok' && response.task) {
            if (callback) callback(null, response.task);
          } else {
            const msg = response?.message || 'Не удалось загрузить задачу';
            if (callback) callback(msg, null);
          }
        });
      });
    },
    [socket]
  );

  return {
    createGlobalImageSearchTask,
    getGlobalSearchTaskList,
    getGlobalSearchTaskDetail,
  };
}
